export default [
  {
    path: '/MaterialBackHis',//历史回望
    name: 'BackHisPage',
    component: () => import('@/view/MaterialSpa/BackHis.vue')
  },
  {
    path: '/MaterialMemory',//投洽会20周年纪念画册 投洽会20周年回顾展
    name: 'MemoryPage',
    component: () => import('@/view/MaterialSpa/Memory.vue')
  },
  {
    path: '/MaterialHisPic',//历届精彩照片
    name: 'HisPicPage',
    component: () => import('@/view/MaterialSpa/HisPic.vue')
  },
  {
    path: '/MaterialHisPicList',//历届精彩照片列表
    name: 'HisPicListPage',
    component: () => import('@/view/MaterialSpa/HisPicList.vue')
  },
  // {
  //   path: '/MaterialReview',//投洽会10周年回顾展 
  //   name: 'reviewPage',
  //   component: () => import('@/view/MaterialSpa/review.vue')
  // },
  // {
  //   path: '/MaterialINTexpress',//国际投资快报
  //   name: 'INTexpressM',
  //   component: () => import('@/view/MaterialSpa/INTexpress.vue')
  // },
  {
    path: '/MaterialVideoList',//世界政要名流谈投洽会
    name: 'VideoListSpaPage',
    component: () => import('@/view/MaterialSpa/VideoList.vue'),
  },{
    path: '/MaterialVideoDet',//世界政要名流谈投洽会详情
    name: 'VideoSpaPage',
    component: () => import('@/view/MaterialSpa/VideoDetail.vue'),
  },
  
]




// WEBPACK FOOTER //
// ./src/router/MaterialSpa.js